/**
 * Auth-Helfer.
 * Der eigentliche Token sitzt als HttpOnly-Cookie `kispro_access_token`
 * auf der Domain `.kispro.de` – JS hat keinen Zugriff darauf.
 *
 * Wir tracken nur die geschätzte Restlaufzeit in localStorage, um den
 * 12-min-Refresh-Loop intelligent zu steuern (analog token-refresh.js).
 */

const LOGIN_BASE = import.meta.env.VITE_LOGIN_BASE_URL;
const STORAGE_KEY = 'kispro_token_expires';

export function getEstimatedExpiry(): number {
  try {
    return parseInt(localStorage.getItem(STORAGE_KEY) ?? '0', 10);
  } catch {
    return 0;
  }
}

export function setEstimatedExpiry(expiresInSeconds: number): void {
  try {
    localStorage.setItem(STORAGE_KEY, String(Date.now() + expiresInSeconds * 1000));
  } catch {
    /* ignore */
  }
}

export function clearEstimatedExpiry(): void {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    /* ignore */
  }
}

export async function refreshToken(): Promise<boolean> {
  const r = await fetch(`${LOGIN_BASE}/api/auth/refresh`, {
    method: 'POST',
    credentials: 'include',
  });
  if (r.ok) {
    const data = (await r.json().catch(() => null)) as { expires_in?: number } | null;
    setEstimatedExpiry(data?.expires_in ?? 900);
    return true;
  }
  if (r.status === 401) {
    clearEstimatedExpiry();
    return false;
  }
  // Andere Fehler ignorieren – Loop versucht es später erneut
  return true;
}

export function redirectToLoginPage(reason?: string): void {
  const redirect = encodeURIComponent(window.location.href);
  const reasonPart = reason ? `&reason=${reason}` : '';
  window.location.href = `${LOGIN_BASE}/login?redirect=${redirect}${reasonPart}`;
}

export async function logout(): Promise<void> {
  try {
    await fetch(`${LOGIN_BASE}/api/auth/logout`, { method: 'POST', credentials: 'include' });
  } catch {
    /* ignore */
  }
  clearEstimatedExpiry();
  window.location.href = `${LOGIN_BASE}/login`;
}
